import { useEffect, useState } from 'react';
import { SITE_KEY } from '../utils/constants';

/**
 * Read the active site ID from localStorage. The Sidebar component is the
 * authoritative writer; this hook just exposes the value to pages that need
 * to scope their queries.
 *
 * Re-checks on `storage` events so multi-tab site changes propagate.
 */
export function useCurrentSite(): { siteId: string | null } {
  const [siteId, setSiteId] = useState<string | null>(
    () => (typeof window === 'undefined' ? null : localStorage.getItem(SITE_KEY)),
  );

  useEffect(() => {
    function onStorage(e: StorageEvent) {
      if (e.key === SITE_KEY) {
        setSiteId(e.newValue);
      }
    }
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);

  return { siteId };
}
